<template>
  <NoteList :delete-permission="'delete_customer'"
            :change-permission="'change_customer'"
            :object-uuid="customer.uuid" plural-object-name="customers" object-name="customer"/>
</template>

<script>
  import NoteList from "./../../../notes/NotesList";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "Notes",
    components: {NoteList},
    computed: {
      ...mapState({
        customer: state => state.customer,
      }),
    },
  }
</script>

<style scoped>

</style>
